import { ACTIONS } from './constants';

export const getCarInstance = (id) => {
  return { type: ACTIONS.GET_CAR_INSTANCE, payload: { id } };
};

export const patchCarInstance = (
  carInstance,
  id,
  loadImage,
  phases,
  phPayload,
  customerCarInstance = false
) => {
  return {
    payload: { carInstance, customerCarInstance, id, loadImage, phPayload, phases },
    type: ACTIONS.PATCH_CAR_INSTANCE,
  };
};

export const dropErrors = () => {
  return { type: ACTIONS.DROP_ERRORS_CAR_INSTANCE };
};

export const dropError = (name, catalog = '') => {
  return { payload: { catalog, name }, type: ACTIONS.DROP_ONE_ERROR_CAR_INSTANCE };
};

export const updateErrors = (errors) => {
  return { payload: { errors }, type: ACTIONS.UPDATE_ERRORS_CAR_INSTANCE };
};

export const forceValidateCarInstance = (forceValidate = false) => {
  return { payload: { forceValidate }, type: ACTIONS.VALIDATE_CAR_INSTANCE };
};

export const forceValidateComplete = () => {
  return { type: ACTIONS.FORCE_VALIDATE_CAR_INSTANCE };
};

export const setCarInstance = (carInstance) => {
  return { payload: { carInstance }, type: ACTIONS.SET_CAR_INSTANCE };
};

export const scrollTo = (scrollTo) => {
  return { payload: { scrollTo }, type: ACTIONS.SCROLL_TO_INSTANCE };
};

export const clearScroll = () => {
  return { type: ACTIONS.CLEAR_SCROLL_TO_INSTANCE };
};

export const clearCarInstance = () => {
  return { type: ACTIONS.CLEAR_CAR_INSTANCE };
};

export const setError = (message) => {
  return { payload: message, type: ACTIONS.SET_ERROR_CAR_INSTANCE };
};

export const clearError = () => {
  return setError('');
};

export const getCarInstanceById = (id, wsid) => {
  return { payload: { id, wsid }, type: ACTIONS.GET_CAR_INSTANCE_BY_ID };
};

export const updateCarInstanceId = (id) => {
  return { payload: id, type: ACTIONS.UPDATE_CAR_INSTANCE_ID };
};

export const changeCarInstance = (carInstance, id, loadImage, phases, phPayload) => {
  return {
    payload: { carInstance, id, loadImage, phPayload, phases },
    type: ACTIONS.CHANGE_CAR_INSTANCE,
  };
};

export const getDealersParams = (currentDealerId) => {
  return { payload: { currentDealerId }, type: ACTIONS.GET_DEALERS_PARAMS };
};

export const setImage = ({ image }) => {
  return { payload: { image }, type: ACTIONS.SET_IMAGE };
};

export const declineDropErrors = (declineDropErrors = true) => {
  return { payload: { declineDropErrors }, type: ACTIONS.DECLINE_DROP_ERRORS };
};

export const openCarInstance = () => {
  return { payload: {}, type: ACTIONS.OPEN_BLOCK };
};

export const closeCarInstance = () => {
  return { payload: {}, type: ACTIONS.CLOSE_BLOCK };
};

export const openCarInstanceDetails = () => {
  return { payload: {}, type: ACTIONS.OPEN_DETAILS };
};

export const closeCarInstanceDetails = () => {
  return { payload: {}, type: ACTIONS.CLOSE_DETAILS };
};

export const disableCarInstance = () => {
  return { payload: {}, type: ACTIONS.DISABLE };
};

export const enableCarInstance = () => {
  return { payload: {}, type: ACTIONS.ENABLE };
};

export const setCarInstanceCollapsable = (value) => {
  return { payload: value, type: ACTIONS.SET_COLLAPSABLE };
};

export const setCarRequiredFields = (fields) => {
  return { payload: fields, type: ACTIONS.SET_CAR_REQUIRED_FIELDS };
};

export const setCarHiddenFields = (fields) => {
  return { payload: fields, type: ACTIONS.SET_CAR_HIDDEN_FIELDS };
};

export const setCarDisableFields = (fields) => {
  return { payload: fields, type: ACTIONS.SET_CAR_DISABLE_FIELDS };
};

export const setCarInstanceFetch = (fetch) => {
  return { payload: fetch, type: ACTIONS.SET_FETCH_CAR_INSTANCE };
};

export const setPatchIsNew = (patch) => {
  return { payload: patch, type: ACTIONS.PATCH_IS_NEW };
};

export const setIsPatching = (patch) => {
  return { payload: patch, type: ACTIONS.SET_PATCHIG_CAR_INSTANCE };
};

export const setFetchDealerParam = (status) => {
  return { payload: status, type: ACTIONS.SET_FETCH_DEALERS_PARAMS };
};

export const setDealerParams = (dealersParams) => {
  return { payload: { dealersParams }, type: ACTIONS.CHANGE_DEALERS_PARAMS };
};

export const updateNestedErrors = ({ errors, field }) => {
  return { payload: { errors, field }, type: ACTIONS.UPDATE_NESTED_ERRORS };
};

export const updateNestedValues = ({ field, values }) => {
  return { payload: { field, values }, type: ACTIONS.UPDATE_NESTED_VALUES };
};
